/* ==========================================================
   SWAYD USA - Country/Region Selection Popup Logic
   Client-side geo-IP lookup (Shopify has no PHP backend,
   so this replaces the old wp_ajax + ip-api.com flow)

   FIX v3: Ab session COOKIE use ho raha hai (sessionStorage
   ki jagah). Farq ye hai:
   - sessionStorage sirf USI TAB tak mehdood hota hai (naya
     tab kholne par phir popup dikh jata tha - yehi bug tha)
   - Session cookie (bina expiry date ke) poore BROWSER me
     (sab tabs me) SHARE hota hai, aur sirf tab clear hota
     hai jab user poora browser band kare (sirf ek tab nahi)
   ========================================================== */

document.addEventListener('DOMContentLoaded', function () {

  // ---- Duplicate execution guard ----
  if (window.swaydPopupInitialized) return;
  window.swaydPopupInitialized = true;

  // ---- CONFIG ----
  var EU_REDIRECT_URL = 'https://swayd.eu/';
  var OTHER_EU_URL = 'https://swayd.eu/';
  var OTHER_REST_URL = window.location.origin; // stays on SWAYD USA
  var COOKIE_NAME = 'swayd_popup_shown'; // session cookie (no expiry)
  var GEO_API = 'https://ipwho.is/'; // HTTPS, no key required

  var EU_COUNTRIES = ['AT','BE','BG','CY','CZ','DE','DK','EE','ES','FI','FR','GR','HR','HU','IE','IT','LT','LU','LV','MT','NL','PL','PT','RO','SE','SI','SK','GB','NO','CH'];

  var EU_COUNTRY_NAMES = {
    AT: 'Austria', BE: 'Belgium', BG: 'Bulgaria', HR: 'Croatia', CY: 'Cyprus',
    CZ: 'Czech Republic', DK: 'Denmark', EE: 'Estonia', FI: 'Finland', FR: 'France',
    DE: 'Germany', GR: 'Greece', HU: 'Hungary', IE: 'Ireland', IT: 'Italy',
    LV: 'Latvia', LT: 'Lithuania', LU: 'Luxembourg', MT: 'Malta', NL: 'Netherlands',
    PL: 'Poland', PT: 'Portugal', RO: 'Romania', SK: 'Slovakia', SI: 'Slovenia',
    ES: 'Spain', SE: 'Sweden', GB: 'United Kingdom', NO: 'Norway', CH: 'Switzerland'
  };

  // ---- Session cookie helpers ----
  // Expiry date NAHI di jati -> browser ise "session cookie" treat karta
  // hai: sab tabs me shared, aur sirf poora browser band karne par clear.
  function setShownFlag() {
    document.cookie = COOKIE_NAME + '=yes;path=/';
  }

  function wasShown() {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + COOKIE_NAME + '=');
    if (parts.length === 2) return parts.pop().split(';').shift() === 'yes';
    return false;
  }

  // ---- Build EU dropdown popup ----
  function buildEuPopup() {
    if (document.querySelector('.eu-popup')) return;

    var options = '<option value="">Choose your country</option>';
    for (var code in EU_COUNTRY_NAMES) {
      options += '<option value="' + code + '">' + EU_COUNTRY_NAMES[code] + '</option>';
    }

    var html =
      '<div class="country-popup-overlay eu-popup">' +
        '<div class="country-popup">' +
          '<span class="eu-popup-close">&times;</span>' +
          '<div class="popup-content">' +
            '<h3>Please Select Your Country</h3>' +
            '<select id="eu-country-select" class="country-select">' + options + '</select>' +
            '<p class="disclaimer">By selecting your country, you will be redirected to our EU site.</p>' +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.insertAdjacentHTML('beforeend', html);
  }

  // ---- Build Region choice popup (Canada / Australia) ----
  function buildOtherPopup() {
    if (document.querySelector('.other-popup')) return;

    var html =
      '<div class="country-popup-overlay other-popup">' +
        '<div class="country-popup">' +
          '<span class="eu-popup-close">&times;</span>' +
          '<div class="popup-content">' +
            '<h3>Choose Your Region</h3>' +
            '<button class="region-choice" data-url="' + OTHER_EU_URL + '">Europe</button>' +
            '<button class="region-choice" data-url="' + OTHER_REST_URL + '">Rest of World</button>' +
            '<p class="disclaimer">By selecting your region, you will be redirected accordingly.</p>' +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.insertAdjacentHTML('beforeend', html);
  }

  function attachPopupEvents() {
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('eu-popup-close')) {
        var overlay = e.target.closest('.country-popup-overlay');
        if (overlay) overlay.remove();
      }
      if (e.target.classList.contains('country-popup-overlay')) {
        e.target.remove();
      }
      if (e.target.classList.contains('region-choice')) {
        var url = e.target.getAttribute('data-url');
        if (url) window.location.href = url;
      }
    });

    document.addEventListener('change', function (e) {
      if (e.target.id === 'eu-country-select') {
        if (e.target.value) {
          window.location.href = EU_REDIRECT_URL;
        }
      }
    });
  }

  function showPopup(region) {
    if (region === 'eu') {
      buildEuPopup();
      document.querySelector('.eu-popup').style.display = 'block';
    } else if (region === 'other') {
      buildOtherPopup();
      document.querySelector('.other-popup').style.display = 'block';
    }
  }

  function determineRegion(countryCode, continentCode) {
    if (countryCode === 'US' || continentCode === 'Asia') {
      return 'none';
    }
    if (EU_COUNTRIES.indexOf(countryCode) !== -1) {
      return 'eu';
    }
    if (countryCode === 'CA' || countryCode === 'AU') {
      return 'other';
    }
    return 'none';
  }

  // ---- Main ----
  if (wasShown()) {
    return; // is browser session me (kisi bhi tab me) already ho chuka hai
  }

  // Flag geo-check shuru hone se PEHLE hi set kar dete hain, taake
  // agar user fetch complete hone se pehle hi doosre tab/page pe
  // chala jaye, to dobara trigger na ho.
  setShownFlag();

  attachPopupEvents();

  fetch(GEO_API)
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (!data || data.success === false) return;
      var countryCode = data.country_code;
      var continentCode = data.continent; // e.g. "Asia", "Europe"
      var region = determineRegion(countryCode, continentCode);
      if (region !== 'none') {
        showPopup(region);
      }
    })
    .catch(function (err) {
      console.error('SWAYD Country Popup: geo lookup failed', err);
    });

});